import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild  } from '@angular/core';
import { NgForm } from '@angular/forms';

import { Student } from '../../interfaces/student';
import { StudentDataService } from '../../services/student-data.service';
import { TelemetryService } from '../../services/telemetry.service';

import { environment } from 'environments/environment';

// Icons
import { faPen, faQuestionCircle, faSpinner } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'shared-student-login-form',
  templateUrl: './student-login-form.component.html',
  styleUrls: ['./student-login-form.component.scss'],
  providers: [StudentDataService],
  standalone: false
})
export class StudentLoginFormComponent implements AfterViewInit {

  @Input() customerId: number | null = null;
  @Input() student: Student | null = null;
  @Output() studentLoginSavedEvent = new EventEmitter<Student | null>();
  @ViewChild('studentLoginForm') public form: NgForm;

  environment = environment;
  isInvalidSubmitted = false;

  // Progress flags
  errorSaving = '';
  isSaving = false;

  // Icons
  faSpinner = faSpinner;

  constructor(
    private studentDataService: StudentDataService,
    private telemetryService: TelemetryService
  ) { }

  ngAfterViewInit() {

    // Add telemetry
    this.setTelemetry();
  }

  cancel() {

    // Emit output that student form has been canceled
    this.studentLoginSavedEvent.emit(null);
  }

  onAccountChange() {

    // When an error showed up due to existing account, clear the error if the account is changed
    this.errorSaving = null;
  }

  save() {

    // Immediately leave if we're already saving
    if (!this.form.valid || this.isSaving) {

      // Show required fields
      this.isInvalidSubmitted = !this.form.valid;
      return;
    }

    // Show spinner
    this.isSaving = true;

    // Reset the status
    this.errorSaving = '';

    // Prepare payload to save
    const payload = {
      CustomerId: this.customerId,
      Student: this.student
    };

    // Create student profile
    this.studentDataService.save(payload)
      .subscribe(
        (value) => {
          console.log('SUCCeSS: ', value);

          // Process value
          this.onSaveSuccess(value);

          // Hide spinner
          this.isSaving = false;
        },
        (error) => {
          console.log('ERROR: ', error);

          // Set the error
          this.errorSaving = error.error;

          // Hide spinner
          this.isSaving = false;
        }
      );
  }

  private onSaveSuccess(result: any) {

    // Emit output that student has been successfully created
    this.student.Account = result.Account;
    this.student.Secret = result.Secret;
    this.studentLoginSavedEvent.emit(this.student);
  }

  private setTelemetry() {
    setTimeout(() => this.telemetryService.inject('CLICK', 'student-form-cancel', null, true));
    setTimeout(() => this.telemetryService.inject('CLICK', 'student-form-submit', null, true));
  }
}
